import React from "react";
import { T } from "../../../context/LanguageContext";
import { useFetchOrderSummary } from "../../../apis/orderApis";

interface OrderSummaryStatsProps {
  selectedCount: number;
  totalCount: number;
}

export function OrderSummaryStats({ selectedCount, totalCount }: OrderSummaryStatsProps) {
  const { data: summary, isLoading } = useFetchOrderSummary({ type: "All Time" });

  const items = [
    { label: "Selected", count: selectedCount, color: "text-blue-600 font-bold" },
    { label: "Total", count: totalCount, color: "text-slate-800 font-bold" },
    { label: "New", count: summary?.newOrder ?? 0, color: "text-blue-600 font-bold" },
    { label: "Created", count: summary?.orderCreated ?? 0, color: "text-purple-600 font-bold" },
    { label: "Pick List", count: summary?.picklist ?? 0, color: "text-amber-600 font-bold" },
    { label: "Packed", count: summary?.packed ?? 0, color: "text-emerald-600 font-bold" },
    { label: "Dispatched", count: summary?.dispatched ?? 0, color: "text-blue-600 font-bold" },
  ];

  if (isLoading && !summary) {
    return (
      <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-lg border border-gray-200 shadow-2xs text-[11px] font-medium min-h-8 animate-pulse text-gray-400">
        <T>Loading summary...</T>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2 bg-gradient-to-b from-white/20 to-white/60 backdrop-blur-xl transition-all duration-300 px-3 py-1.5 rounded-lg border border-gray-300 shadow-inner text-[11px] select-none font-medium min-h-8">
      {items.map((item, idx) => (
        <React.Fragment key={item.label}>
          {idx > 0 && <span className="h-3 w-px bg-gray-300 hidden sm:inline" />}
          <div className="flex items-center gap-1.5">
            <span className="text-gray-500 text-[11px]"><T>{item.label}</T>:</span>
            <span className={`text-[11px] ${item.color}`}>
              {item.count}
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default OrderSummaryStats;
